import FeatureLayer from "@arcgis/core/layers/FeatureLayer";
import React, { useEffect, useState } from "react";


export default function SuggestionDisplay(props) {
    const [suggestionsDisplay, setSuggestionsDisplay] = useState(null);
    const [suggestionsDisplayHeader, setSuggestionsDisplayHeader] = useState(null);

    function getResultFromAGO(i) {
        const result = props.suggestions.results[0].results[i]
        props.setSearchedParcel(result.text)
        props.suggestions.results[0].source.getResults({ suggestResult: result }).then((r) => {
            const pnumField = props.searchManager.getPnumField(props.searchType);
            const pnumValue = r[0].feature.attributes[pnumField]; // value of the fromColumn field
            const calcMap = props.searchManager.getLinkToMapping(props.searchType);

            const queryFeat = new FeatureLayer({
                url: calcMap.api
            });
            // See if the returned parcel number is a parent parcel in the calc dataset
            const query = queryFeat.createQuery();

            // Get address.... clean up later
            if (props.searchType !== 1) {
                props.setAddress(r[0].feature.attributes['address'])
            }

            // WHERE calc.parent = retrieved parcel number
            query.where = calcMap.parcelParentField + ` = '${pnumValue}'`
            query.outFields = calcMap.outFields.join(', ');
            queryFeat.queryFeatures(query).then(function (response) {
                let parentResponse;
                if (response.features.length > 0) {
                    parentResponse = response
                } else {
                    // lookup parent
                    const parentQuery = queryFeat.createQuery();
                    parentQuery.where = calcMap.parcelField + ` = '${pnumValue}'`
                    parentQuery.outFields = calcMap.parcelParentField
                    // look up fields again, using parent
                    queryFeat.queryFeatures(parentQuery).then(function (pqr) {
                        const parentParcel = pqr[0].feature.attributes[calcMap.parcelParentField];
                        const reQuery = queryFeat.createQuery();
                        reQuery.where = calcMap.parcelParentField + ` = '${parentParcel}'`
                        reQuery.outFields = calcMap.outFields.join(', ');
                        queryFeat.queryFeatures(reQuery).then(function (rqr) {
                            if (rqr.features.length > 0) {
                                parentResponse = rqr
                            } else {
                                parentResponse = false //if still null
                            }
                        })
                    })
                }

                if (parentResponse) {

                    let recs = [] // [{}, {}, ...]

                    // grab just attributes
                    for (let i = 0; i < parentResponse.features.length; i++) {
                        recs.push(parentResponse.features[i].attributes)
                    };


                    // pre-process recs ------
                    const dateFields = []
                    const linkFields = []

                    //   format dates
                    if (dateFields.length) {
                        recs.forEach(rec => {
                            dateFields.forEach(df => {
                                if (rec[df]) {
                                    const d = new Date(rec[df]);
                                    rec[df] = d.toLocaleDateString()
                                } else {
                                    rec[df] = 'Not Available'
                                }
                            })
                            return rec;
                        });
                    };
                    //   format links
                    if (linkFields.length) {
                        recs.forEach(rec => {
                            linkFields.forEach(lf => {
                                if (rec[lf]) {
                                    if (rec[lf].slice(0, 4) === 'http') {
                                        rec[lf] = <a href={rec[lf]} target="_blank" rel="noreferrer">Link</a>
                                    } else {
                                        rec[lf] = <a href={'https://' + rec[lf]} target="_blank" rel="noreferrer">Link</a>
                                    }

                                } else {
                                    rec[lf] = 'Not Available'
                                }
                            })
                            return rec;
                        });
                    };
                    props.setRequestLoading(false);
                    props.setResults(recs);
                } else {
                    console.log('Data not found for parcel number.')
                }
            })
        })
    }


    useEffect(() => {
        try {
            if (Object.keys(props.suggestions).length > 0) {
                const sd = props.suggestions.results[0].results.map((a, k) => {
                    let mainStr;
                    let contextDisplayCells;
                    mainStr = a.text.split('^')[0]
                    contextDisplayCells = a.text.split('^')
                        .filter((g) => g !== mainStr)
                        .map((g, i) => {
                            return (
                                <td key={i}>
                                    {g}
                                </td>
                            )
                        })
                    return (

                        <tr key={a.key}
                            className='border border-city-white border-solid hover:cursor-pointer hover:bg-city-green-dark hover:text-city-white text-left [&>*:nth-child(odd)]:border-r [&>*:nth-child(odd)]:border-r-solid [&>*:nth-child(odd)]:border-r-city-white [&>*:nth-child(odd)]:bg-city-green-medium/40'
                            onClick={() => { props.setRequestLoading(true); getResultFromAGO(k) }}
                        >
                            <td>
                                {mainStr.toUpperCase()}
                            </td>
                            {contextDisplayCells ? contextDisplayCells : null}
                        </tr>
                    )
                })
                setSuggestionsDisplay(sd);
            }
        } catch {
            setSuggestionsDisplay(null);
        }
        try {
            if (Object.keys(props.suggestions).length > 0) {
                const sdh = props.suggestions.results[0].source.suggestionTemplate
                    .replaceAll('{', '')
                    .replaceAll('}', '')
                    .split('^')
                    .map((h, i) => {
                        return (
                            <td key={i} className='py-3 px-3.5 text-xl font-bold'>
                                {props.searchManager.getLabelForField(props.searchType, h)}
                            </td>
                        )
                    })
                setSuggestionsDisplayHeader(sdh);
            }
        } catch {
            setSuggestionsDisplayHeader(null);
        }
        // eslint-disable-next-line
    }, [props.suggestions])


    useEffect(() => {
        setSuggestionsDisplay(null);
        setSuggestionsDisplayHeader(null);
        props.setResults([]);
        // eslint-disable-next-line
    }, [props.searchType])

    return (
        props.results.length === 0 && <div className={"h-full w-full overflow-auto flex"}>
                
                {props.requestLoading && (
                <div className="w-full h-full items-center justify-center flex">
                    <div className="text-3xl"> Loading... </div>
                </div>
                )}
                {(!props.requestLoading && suggestionsDisplay) && 
                    (
                    <div>
                    <table className="border-collapse my-0 md:my-6 mx-0 shadow-lg table-fixed w-full">
                        <thead>
                            <tr>
                                {suggestionsDisplayHeader}
                            </tr>
                        </thead>
                        <tbody>
                            {suggestionsDisplay}
                        </tbody>
                    </table>
                    <div className="pt-1 text-xs">
                    If you cannot find the address or parcel number you are looking for, try looking it up <a className="underline text-city-green-medium" href="https://base-unit-tools.netlify.app/search" target="_blank" rel="noopener noreferrer">here</a>.
                    </div>
                    </div>
                    )
                }
                  
        </div>
    )
}